import { Store } from "vuex/types/index"

import { RootState } from "~/store/store.types"

/**
 * Validate the store has the default app data
 *
 * @param {*} store
 * @returns
 */
export function isInitialized (authed: boolean, store: Store<RootState>): boolean {
  const { state: { venues, events, content } } = store
  const venuesData = venues && venues.data
  const eventCategories = events.categories && events.categories.data
  const contentCategories = content.categories && content.categories.data

  const validateState = [venuesData, ...(authed ? [eventCategories, contentCategories] : [])]

  return !validateState.some((state = {}) => Object.keys(state).length <= 0)
}
